import React from 'react';
import { ScienceExhibition2026 } from '../views';

const BlogNewsroomPage = () => {

return <ScienceExhibition2026/>
};

export default BlogNewsroomPage;